import script from "./Accordion.vue?vue&type=script&setup=true&lang=js"
export * from "./Accordion.vue?vue&type=script&setup=true&lang=js"

import "./Accordion.vue?vue&type=style&index=0&id=cd81c1d6&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cd81c1d6"]])

export default __exports__